import { asyncRoutes, constantRoutes, lastRouterMap } from '@/router'
import store from '@/store'
const state = {
    routes: [],
    addRoutes: [],
    sideMenuRouters: [],
    pageCurrent: 1,
    pageName: 'parts'
}

const mutations = {
    INIT_ALL: (state, routes) => {
        state.routes = []
        state.addRoutes = []
        state.sideMenuRouters = []
        state.pageCurrent = 1
        state.pageName = 'parts'
    },
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = constantRoutes.concat(routes).concat(lastRouterMap)
    },
    SET_MENU_ROUTERS: (state, menuid) => {
        if (menuid === 'index') return
        // 筛选 当前展示模块下的 路由
        const routerMap = state.routes.filter((item, index) => {
            return item.meta.menuid === menuid
        })
        var arr = routerMap
        // 判断是否为配件，如果不是，需要只展示子集路由
        if (!['parts', 'selfhelp'].includes(menuid)) {
            arr = []
            routerMap.forEach(res => {
                if (res.meta.menuid === menuid) {
                    arr = arr.concat(res.children)
                } else {
                    arr.push(res)
                }
            })
        }
        state.sideMenuRouters = arr
    },
    UPPAGE_CURRENT: (state, data) => {
        state.pageCurrent = data
    },
    UPPAGE_CURRENT_NAME: (state, data) => {
        state.pageName = data
    }
}

const actions = {
    generateRoutes({ commit }, roles) {
        return new Promise(resolve => {
            console.log('asyncRoutes')
            console.log(asyncRoutes)
            const data = cloneObj(asyncRoutes)
            const accessedRouters = filterAsyncRouter(data)
            commit('SET_ROUTES', accessedRouters)
            commit('SET_MENU_ROUTERS', store.state.permission.pageName)
            commit('UPPAGE_CURRENT_NAME', store.state.permission.pageName)
            resolve(accessedRouters)
        })
    },
    changeMenu({ commit }, roles) {
        commit('SET_MENU_ROUTERS', roles)
    },
    uPageCurrnet({ commit }, data) {
        commit('UPPAGE_CURRENT', data)
    },
    uPageCurrnetName({ commit }, data) {
        commit('UPPAGE_CURRENT_NAME', data)
    },
    initAll({ commit }) {
        return new Promise((resolve, reject) => {
            commit('UPPAGE_CURRENT_NAME', {})
            resolve()
        })
    }
}
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param access
 * @param route
 */
function hasPermission(route) {
    const auth = store.getters.auth
    return auth.indexOf(route.meta.auth) >= 0
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param async
 * @param access
 */
function filterAsyncRouter(async) {
    const asyRoute = async.filter(route => {
    // 先判断父级有没有权限
        if (hasPermission(route)) {
            // 如果没有子路由
            if (!route.children) return hasPermission(route)
            // 如果有子路由 递归调用
            route.children = filterAsyncRouter(route.children)
        } else {
            return false
        }
        return true
    })
    return asyRoute
}
function cloneObj(obj) {
    var newObj = {}
    if (obj instanceof Array) {
        newObj = []
    }
    for (var key in obj) {
        var val = obj[key]
        newObj[key] = typeof val === 'object' ? cloneObj(val) : val
    }
    return newObj
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
